var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container",style:(`height: ${_vm.height}px`),attrs:{"tabindex":"0"}},[_c('clientOnly',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticClass:"pdf-container__pdf",attrs:{"src":_vm.src,"page":i}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }